import React from "react";
import ConnectionsFormWidget from "../../components/Widgets/ConnectionsWidgets/ConnectionsFormWidget";

const ConnectionForm = (props) => {
  return <ConnectionsFormWidget {...props} />;
};

export default ConnectionForm;
